import { CircularProgress, InputLabel, Typography } from '@material-ui/core';
import { Select, SelectArrowDownIcon } from '@room-match/shared-ui-components';
import CloseIcon from 'shared/components/Icon/CloseIcon'; // Use talent-app level folder close icon
import React, { useState } from 'react';
import {
  ActionsContainer,
  CloseButton,
  Content,
  CustomButton,
  CustomDialog,
  CustomDialogContent,
  Header,
  useStyles,
} from './CategoryModal.styles';
import { COLORS } from 'shared/constants/COLORS';

interface Props {
  show: boolean;
  onselect: (category: string) => void;
  edit?: boolean;
  close: () => void;
  added: string[];
}

const CategoryModal: React.FC<Props> = ({ show, onselect, edit, close, added }) => {
  const categories = [
    { value: 'Commercial', key: 'Commercial' },
    { value: 'Film', key: 'Film' },
    { value: 'Television', key: 'Television' },
    { value: 'Theatre', key: 'Theatre' },
    { value: 'Print / Fashion', key: 'Print / Fashion' },
    { value: 'Training', key: 'Training' },
    { value: 'Voice', key: 'Voice' },
    { value: 'Stunt', key: 'Stunt' },
    { value: 'Corporate', key: 'Corporate' },
    { value: 'MC/Presenting', key: 'MC/Presenting' },
    { value: 'Extras', key: 'Extras' },
    { value: 'Other', key: 'Other' },
  ].filter((item) => !added.includes(item.value));

  const classes = useStyles();
  const [category, setcategory] = useState(categories[0]?.value);
  const [adding, setAdding] = useState(false);

  const handleChange = (e: any) => {
    setcategory(e.target.value);
  };

  return (
    <CustomDialog style={{ zIndex: 2 }} open={show} onClose={close} maxWidth="sm" aria-labelledby="simple-dialog-title">
      <CustomDialogContent>
        <CloseButton>
          <CloseIcon style={{ width: '14px' }} onClick={close} />
        </CloseButton>
        <Header>
          <Typography style={{ fontSize: 24 }}>{edit ? 'Edit' : 'Add'} Resume Category</Typography>
        </Header>
        <Content>
          <InputLabel>Category Name</InputLabel>
          <Select
            variant="outlined"
            fullWidth
            data={categories}
            placeHolder={'Select'}
            value={category}
            // IconComponent={SelectArrowDownIcon}
            className={classes.select}
            onChange={handleChange}
          />
        </Content>

        <ActionsContainer>
          <CustomButton
            variant="contained"
            color="primary"
            onClick={() => {
              setAdding(true);
              onselect(category);
            }}
            fullWidth
            disabled={adding}
          >
            {adding ? <CircularProgress style={{ color: COLORS.WHITE }} size={20} /> : 'Select'}
          </CustomButton>
          <CustomButton style={{ backgroundColor: 'transparent' }} onClick={close} fullWidth>
            Cancel
          </CustomButton>
        </ActionsContainer>
      </CustomDialogContent>
    </CustomDialog>
  );
};

export default CategoryModal;
